import React from "react";
import ActivePassiveItemGenericSkeleton from "./ActivePassiveItemGenericSkeleton";

function ActivePassiveItemDetailSkeleton() {
  return (
    <>
      <ActivePassiveItemGenericSkeleton />
    </>
  );
}

export default ActivePassiveItemDetailSkeleton;
